// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__kYQXN","info":"UpdateTermsInfo_info__yl_bB"};